var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-t-dark- p-4 side-menu-main-wrapper"},[_c('b-row',[_c('b-col',{staticClass:"text-center"},[_c('img',{staticClass:"side-logo",attrs:{"src":"img/logo/timpel.png"}})])],1),_c('MenuItems')],1)}
var staticRenderFns = []

export { render, staticRenderFns }